import ContactUs from "views/ContactUsView";

export default function Page() {
  return (
    <>
      <ContactUs />
    </>
  );
}
